import React from 'react'

function Header() {

    

  return (
    <header className='w-100' style={{backgroundColor: '#a6191f'}}>
        <div className='p-2 text-center'>
            <img src="https://gadvasuias.ctpltest.online/images/logo.png" alt="logo" className='header_logo'/>
        </div>
    </header>
  )
}

export default Header